var script = document.createElement('script');
script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
script.onload = function() {
    console.log("GSAP MOTOR BĚŽÍ");

    var pokusy = 0;
    var maxPokusy = 20;

    // HLEDACÍ FUNKCE: Koukáme, jestli už se ta tvoje sekce objevila na webu
    const checkExist = setInterval(function() {
       pokusy++;
       const kontejner = document.querySelector(".kontejner-3d");
       
       if (kontejner) {
          console.log("SEKCE NALEZENA - STARTUJI POŘÁDNÝ SKOK");
          
          gsap.to(kontejner, {
              y: -25,            // <-- VÝŠKA SKOKU: Změň na -35 pro extrém, nebo na -15 pro zlatý střed
              duration: 1.5,     // <-- RYCHLOST: Menší číslo (např. 0.8) = zběsilé skákání. Větší číslo (např. 2) = pomalé vznášení
              repeat: -1,        // Nekonečná smyčka
              yoyo: true,        // Plynulý návrat
              ease: "sine.inOut" // Hladký pohyb bez záseků
          });

          clearInterval(checkExist); // Našli jsme ji, přestaneme hledat
       } else if (pokusy >= maxPokusy) {
          console.log("SEKCE NENALEZENA - KONČÍM HLEDÁNÍ");
          clearInterval(checkExist); // Po 20 pokusech (10 vteřin) přestaneme hledat
       }
    }, 500); // Kontrola každých 500ms
};
document.head.appendChild(script);